import StudyAbroadButtonContainer from './StudyAbroadButtonContainer';
export default StudyAbroadButtonContainer;
